import React from 'react';
import ProfileDelete from '@/components/Profiles/ProfileDelete';
import History from '@/components/_common/History/History';
import { useAppSelector } from '@/redux/hooks';
import { selectCanViewProfileHistory, selectCanDeleteProfiles, selectCanExportProfiles } from '@/redux/selectors/authSelectors';
import ProfileExport from '@/components/Profiles/ProfileExport';
import { CustomerProfile } from '@/redux/slices/slice_types';
import OverflowMenu from './OverflowMenu';

interface ProfileOverflowMenuProps {
  row: CustomerProfile;
}

const ProfileOverflowMenu = ({ row }: ProfileOverflowMenuProps) => {
  const canDeleteProfilePermission = useAppSelector(selectCanDeleteProfiles);
  const viewHistoryPermission = useAppSelector(selectCanViewProfileHistory);
  const canExportProfiles = useAppSelector(selectCanExportProfiles);

  if (!canDeleteProfilePermission && !viewHistoryPermission && !canExportProfiles) {
    return null;
  }

  return (
    <OverflowMenu>
      <ProfileDelete profile={row} />
      <History data={row} />
      <ProfileExport profile={row} />
    </OverflowMenu>
  );
};

export default ProfileOverflowMenu;
